import { render, staticRenderFns } from "./lotto-list.vue?vue&type=template&id=06370472&scoped=true&"
import script from "./lotto-list.vue?vue&type=script&lang=js&"
export * from "./lotto-list.vue?vue&type=script&lang=js&"
import style0 from "./lotto-list.vue?vue&type=style&index=0&id=06370472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06370472",
  null
  
)

export default component.exports